module.exports = __webpack_public_path__ + "img/stars-bg-desktop.88e052e.png";